<script lang="ts">
  import { createEventDispatcher } from "svelte";
  // export let winner: string;
  export let message: string;

  const dispatch = createEventDispatcher();
</script>

<style>
  section {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  h2 {
    width: 100%;
    font-size: 2.5rem;
    text-align: center;
  }

  .fa-times-circle {
    position: absolute;
    top: 5px;
    right: 5px;
    font-size: 1.8rem;
    cursor: pointer;
  }

  .fa-trophy {
    font-size: 5.8rem;
  }

  button {
    margin: 10px 0;
    padding: 10px 20px;
    font-size: 1.1rem;
    font-weight: 600;
    color: white;
    background-color: #805126;
    box-shadow: 1px 1px 3px black;
    cursor: pointer;
  }
  button:active {
    box-shadow: inset 0 0 3px black;
  }

  /* img {
    width: 70px;
    margin-right: 10px;
  } */
</style>

<section>
  <i class="far fa-times-circle" on:click />
  <h2>{message}</h2>
  <i class="fas fa-trophy" />
  <div class="btn-cont">
    <button on:click={() => dispatch('play')}>Play!</button>
  </div>
</section>
